var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var OfferGrid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return "\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 300px));\n    grid-gap: 1rem;\n    padding: 1rem;\n    box-sizing: border-box;\n    width: 100%;\n    background-color: ".concat(props.theme.bgContent(), ";\n    justify-content: center;\n  "); });
var VerticalOfferContainer = function (_a) {
    var children = _a.children;
    return React.createElement(OfferGrid, null, children);
};
export default VerticalOfferContainer;
var templateObject_1;
